module.exports = __webpack_public_path__ + "static/img/5449_phase_function_Paper_PointsHejduk_Prediction.6b5130b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5449_phase_function_Paper_PointsHejduk_Prediction.png
// module id = B4q/
// module chunks = 0